import { useParams } from 'next/navigation'
import React, { useState } from 'react'
import styles from './AddressPicker.module.scss'
import { useLocalisation } from '@/tools/i18n/client'
import { Button, ButtonSize, ButtonVariants, ChevronDownIcon, LocationMarkerIcon } from '@/tools/ui'
import { AddressBookModal } from '@/user/address-book'

interface Props {
  addressText: string | undefined
  color?: string
  isIntersecting: boolean
  showLocationScrollDrawer: boolean
}

export const AddressPicker: React.FC<Props> = ({
  addressText,
  color,
  isIntersecting,
  showLocationScrollDrawer,
}) => {
  const { city } = useParams()
  const { t } = useLocalisation()
  const [isOpenAddressBook, setIsOpenAddressBook] = useState(false)
  const isBrandHeader = color === 'brand'
  const shouldShowAddressInput = (isIntersecting && isBrandHeader) || !isBrandHeader
  const shouldShowCoachmark = !isBrandHeader && city
  const addressPrompt = shouldShowCoachmark ? (
    <span className={styles.addressPrompt}>{city}</span>
  ) : (
    t('address.input-placeholder')
  )

  const handleOpenAddressBook = () => {
    setIsOpenAddressBook(!isOpenAddressBook)
    return
  }

  const handleCloseAddressBook = () => {
    setIsOpenAddressBook(false)
  }

  if (!shouldShowAddressInput) {
    return null
  }

  return (
    <>
      {!showLocationScrollDrawer && (
        <Button
          leadingIcon={LocationMarkerIcon}
          size={ButtonSize.small}
          trailingIcon={ChevronDownIcon}
          variant={ButtonVariants.neutral}
          onClick={handleOpenAddressBook}
        >
          {addressText || addressPrompt}
        </Button>
      )}
      <AddressBookModal
        isOpen={isOpenAddressBook}
        onClose={handleCloseAddressBook}
        onSelect={handleCloseAddressBook}
      />
    </>
  )
}
